export const UNSPECIFIED_LABEL = 'Unspecified';
